<script>
  import {
    ChevronDownIcon,
  } from 'vue-feather-icons'

  export default {
    components: {
      ChevronDownIcon,
    },
    model: {
      event: 'change',
      prop: 'value',
    },
    props: {
      value: {
        type: null,
        default: () => ({})
      },
      label: {
        type: String,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      invisible: {
        type: Boolean,
        default: false,
      },
      hideLabel: {
        type: Boolean,
        default: false,
      },
      customClasses:{
        type: String,
        default: '',
      },
      customLabelClasses:{
        type: String,
        default: '',
      },
      showCount:{
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        isExpanded: false,
        duration: 500,
        durationClass: '',
      }
    },
    computed: {
      totalNotes() {
        if (this.value.notes) {
          return this.value.notes.length;
        }
        return 0;
      },
    },
    created(){
      this.durationClass = `tw-duration-${this.duration}`
      this.isExpanded = !this.invisible
    },
  }
</script>

<template>
  <div class="main-form-group border tw-rounded-25 !tw-relative">
    <label
      v-if="!hideLabel"
      v-fabric-collapse="'collapse-' + name"
      class="
        label-legend btn-collapse 
        tw-flex tw-justify-between 
        !tw-pr-2.5 tw-gap-x-3
        !tw-relative
        !tw--mt-5 !tw--ml-5
        !tw-w-fit !tw-min-w-[10rem]"
      :class="customLabelClasses">
      {{ label }}<span v-if="showCount" class="pd-l-5">({{totalNotes}})</span>
      <transition
        name="rotate-0-180"
        :enter-active-class="'tw-ease-in-out ' + durationClass"
        :leave-active-class="'tw-ease-in-out ' + durationClass"
        css><ChevronDownIcon
        v-show="isExpanded"
        size="18"
        class="!tw-block tw-text-white"
        :class="{
          'rotate-0-180-collapsed': !isExpanded,
          'rotate-0-180-expanded': isExpanded,
        }"
      /></transition>
    </label>
    <slot name="buttons" />
    <FabricCollapse
      :id="'collapse-' + name "
      :default-shown="!invisible"
      :duration="duration"
      hide-header
      :class="['info-detail', customClasses]"
      @expanding="isExpanded = true"
      @collapsing="isExpanded = false">
      <slot />
    </FabricCollapse>
  </div>
</template>
